import React from "react";

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border border-slate-200 rounded-md ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function Btn({ children, variant = "primary", className = "", ...rest }) {
  const styles = {
    primary: "text-white",
    outline: "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "bg-red-600 text-white hover:bg-red-700",
  };
  const inline = variant === "primary" ? { background: "var(--nk-navy)" } : {};
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-md px-3.5 py-2 text-sm font-semibold transition-colors disabled:opacity-50 ${styles[variant]} ${className}`}
      style={inline}
      {...rest}
    >
      {children}
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="nk-overline block mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={`w-full border border-slate-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${props.className || ""}`}
    />
  );
}

export function Select({ children, ...props }) {
  return (
    <select
      {...props}
      className={`w-full border border-slate-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${props.className || ""}`}
    >
      {children}
    </select>
  );
}

export function Empty({ title = "Nothing here yet", hint }) {
  return (
    <div className="text-center py-16 text-slate-400">
      <div className="nk-head text-base font-semibold text-slate-500">{title}</div>
      {hint && <div className="text-sm mt-1">{hint}</div>}
    </div>
  );
}
